import styled from 'styled-components';

const TableRowContainer = styled.div`
  border: ${props => props.header ? 'none' : '1.5px solid #E2E5EF'};
  color: ${props => props.header ? '#8b93a8' : '#626671'};
  border-radius: 3px;
  // width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  padding: 10px;
`;

export default TableRowContainer;




// WEBPACK FOOTER //
// ./client/Dashboard/components/TableRowContainer.js